import { gql } from '@/__generated__';

const UPDATE_REPORT_TEMPLATE = gql(`#graphql
mutation UpdateReportTemplate($input: UpdateReportTemplateInput!) {
  updateReportTemplate(input: $input) {
    template {
      id
    }
  }
}`);

export default UPDATE_REPORT_TEMPLATE;
